import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import type { Control } from 'react-hook-form';

interface RadioGroupInputProps {
    field: {
        handle: string;
        label?: string;
        type: string;
        instructions?: string;
        options?: Array<{
            label?: string;
            value?: string;
        }>;
    };
    control: Control<Record<string, unknown>>;
}

export default function RadioGroupInput({ field, control }: RadioGroupInputProps) {
    return (
        <FormField
            control={control}
            name={field.handle}
            render={({ field: formField }) => (
                <FormItem>
                    <FormLabel>{field.label}</FormLabel>
                    <FormControl>
                        <div className="space-y-2">
                            {field.options?.map((option) => (
                                <div key={option.value} className="flex items-center space-x-2">
                                    <input
                                        type={field.type === 'checkboxes' ? 'checkbox' : 'radio'}
                                        name={field.handle}
                                        value={option.value || ''}
                                        checked={
                                            field.type === 'checkboxes'
                                                ? ((formField.value as string[]) || []).includes(
                                                      option.value || ''
                                                  )
                                                : formField.value === option.value
                                        }
                                        onChange={(e) => {
                                            if (field.type === 'checkboxes') {
                                                const currentValues =
                                                    (formField.value as string[]) || [];
                                                if (e.target.checked) {
                                                    formField.onChange([
                                                        ...currentValues,
                                                        option.value,
                                                    ]);
                                                } else {
                                                    formField.onChange(
                                                        currentValues.filter(
                                                            (v: string) => v !== option.value
                                                        )
                                                    );
                                                }
                                            } else {
                                                formField.onChange(option.value);
                                            }
                                        }}
                                        className="h-4 w-4"
                                    />
                                    <label
                                        htmlFor={`${field.handle}-${option.value}`}
                                        className="text-sm"
                                    >
                                        {option.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </FormControl>
                    {field.instructions && (
                        <p className="text-muted-foreground text-sm">{field.instructions}</p>
                    )}
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
